import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaEmailAluno = (): TabelaColuna => ({
  Chave: 'emailAluno',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>E-mail</div>
})
